import React from "react";
import { Skeleton } from "components/skeleton";
import "./terminal-row.css";

/** Loading placeholder mirroring TerminalRow's row: serial · type · vendor · status badge. */
function SkeletonTerminalRow() {
  return (
    <div className="tm-row">
      <Skeleton width={140} height={13} />
      <Skeleton width={70} height={13} />
      <Skeleton width={70} height={13} />
      <Skeleton width={64} height={22} borderRadius="99px" />
    </div>
  );
}

export default SkeletonTerminalRow;
